import { defineComponent, h } from 'vue';
import { useRoute } from 'vue-router';

const DynamicDigitalTwinWrapper = defineComponent({
  name: 'DynamicDigitalTwinWrapper',
  setup() {
    const route = useRoute();
    return () => {
      const component = route.meta.dynamicComponent;
      return component ? h(component) : null;
    };
  },
});
export default DynamicDigitalTwinWrapper;
